import { Button, Form, Input, InputNumber, Select } from 'antd'
import React, { useContext } from 'react'
import { PromiseSesionContext } from '../../Machines/ErrorMachine'
import { useNavigate } from 'react-router-dom';

import { ResponseContent } from '../../Models/ResponseContent';
import { PokemonCard } from '../../Models/PokemonCard';
import { addCardToIventary } from '../../Api/Cards';

interface Props{
    card?: PokemonCard
    closeModal?: () => void
}

const { Option } = Select; 

const AddCardForm = ({card, closeModal}:Props) => {
    const {sesion, sendSesion} = useContext(PromiseSesionContext);
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState<boolean>(false);
    const {error, sendError} = useContext(PromiseSesionContext);


    const  onFinish = async (values: FieldType) => {
        try{
            if(!card) return 
            console.log("values", values)
            let obj={
                name:card.id,
                descripcion:"Carta",
                price:values?.precio,
                image_url:card.imageUrl,
                product_type_id:1,
                franchise:"Cartas Pokemon",
                card_id:card.id,
                card_type:values?.card_type || "rare",
                language:values?.language || "EN",
                condition:values?.condition || "NM",



            }

            setLoading(true)
            const result:ResponseContent = await addCardToIventary(obj, values.cantidad)


            sendError({type: "ERROR", data:{message:"Carta agregada", type:"success"}})
            setLoading(false)
            closeModal && closeModal()


        }
        catch(error:any){
            setLoading(false)

            sendError({type: "ERROR", data:{message:"Error al crear la carta"}})
            return;
        }

      };

      const onFinishFailed = (errorInfo: any) => {
        };

      type FieldType = {
        cantidad: number;
        precio: number;
        card_type:string;
        language:string;
        condition:string

      };

  return (
    <div className='LoginForm-Component'>
            
            <Form
                disabled={loading}
                name="basic"
                className='FormLoginComponentForm'
                layout={"vertical"}
                initialValues={{ remember: true, card_type:"rare", language:"EN", condition:"NM", cantidad:1, precio:1.5 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                style={{width:"100%"}}
                autoComplete="off">

                <Form.Item<FieldType>
                label={"Cantidad"}
                name="cantidad"
                style={{width:"100%"}}
                rules={[{ required: true, message: "La cantidad es requerida" }]}
                >
                <InputNumber style={{width:"100%"}}  min={0} />

                </Form.Item>

                <Form.Item<FieldType>
                label={"Precio"}
                name="precio"
                style={{width:"100%"}}

                rules={[{ required: true, message: "El precio es requerido" }]}
                >
                <InputNumber style={{width:"100%"}}  min={0} />

                </Form.Item>

                <Form.Item<FieldType>
                label={"Tipo"}
                name="card_type"
                style={{width:"100%"}}

                >
                <Select
                    placeholder="Selecciona un tipo" // Texto que se muestra antes de seleccionar una opción
                    style={{ width: "100%" }}
                  >
                    {/* Opciones del Select */}
                    <Option value="rare" >Rare</Option>
                    <Option value="holo">Holo</Option>
                    <Option value="reverse">Reverse</Option>
                    <Option value="normal">Normal</Option>
                    <Option value="master ball">Master Ball</Option>
                    <Option value="poke ball">Poke Ball</Option>

                  </Select>
                </Form.Item>

                
                <Form.Item<FieldType>
                label={"Idioma"}
                name="language"
                style={{width:"100%"}}

                >
                <Select
                    placeholder="Selecciona un tipo" // Texto que se muestra antes de seleccionar una opción
                    style={{ width: "100%" }}
                  >
                    {/* Opciones del Select */}
                    <Option value="EN" >Ingles</Option>
                    <Option value="ES" >Español</Option>
                    <Option value="FR" >Frances</Option>
                    <Option value="LA" >Latino</Option>
                  </Select>
                </Form.Item>





                <Form.Item<FieldType>
                label={"Condicion"}
                name="condition"
                style={{width:"100%"}}

                >
                <Select
                    placeholder="Selecciona un tipo" // Texto que se muestra antes de seleccionar una opción
                    style={{ width: "100%" }}
                  >
                    {/* Opciones del Select */}
                    <Option value="NM" >Near Mint</Option>

                  </Select>
                </Form.Item>



                <Form.Item >


                <Button style={{width:"100%"}}  type="primary" htmlType="submit">
                    Agregar
                </Button>

 
                </Form.Item>



            </Form>
            {/* <ButtonPrimary text='Login'></ButtonPrimary> */}

            

    </div>
  )
}

export default AddCardForm